<template>
    <page-layout>
        <template #default>
            <g-loader v-if="isLoading" type="fixed" />
            <div v-else class="account-verification-block">
                <div class="margin-bottom-large">
                    <g-typography text-align="center" tag="h1" font-weight="semibold" value="Verify Your Account" />
                </div>
                <div class="margin-bottom-large account-verification-text">
                    <div class="margin-bottom-normal">
                        <g-typography tag="p"> Verification is required to do the following: </g-typography>
                    </div>
                    <g-media-object v-if="accountMakesPayments" class="margin-bottom-normal">
                        <template #left>
                            <g-icon name="check" color="green-5" />
                        </template>
                        <template #default>
                            <g-typography tag="p"> Manage your shipping address for receiving products. </g-typography>
                        </template>
                    </g-media-object>

                    <g-media-object v-if="accountMakesPayments" class="margin-bottom-normal">
                        <template #left>
                            <g-icon name="check" color="green-5" />
                        </template>
                        <template #default>
                            <g-typography tag="p">Set up payout methods for receiving payments.</g-typography>
                        </template>
                    </g-media-object>

                    <g-media-object class="margin-bottom-normal">
                        <template #left>
                            <g-icon name="check" color="green-5" />
                        </template>
                        <template #default>
                            <g-typography tag="p">
                                Manage your creator accounts for participating in campaigns.
                            </g-typography>
                        </template>
                    </g-media-object>

                    <g-media-object class="margin-bottom-normal">
                        <template #left>
                            <g-icon name="check" color="green-5" />
                        </template>
                        <template #default>
                            <g-typography tag="p">Manage notifications.</g-typography>
                        </template>
                    </g-media-object>

                    <g-media-object class="margin-bottom-normal">
                        <template #left>
                            <g-icon name="check" color="green-5" />
                        </template>
                        <template #default>
                            <g-typography tag="p">View your transaction and conversion history.</g-typography>
                        </template>
                    </g-media-object>
                </div>
                <div class="verification-methods-block margin-bottom-normal">
                    <g-button icon="envelope" shape="round" @click="sendVerificationEmail">Email Link</g-button>
                </div>
                <div class="verification-methods-block padding-top-normal">
                    <g-link type="normal" @click="handleSkip">I don't want to verify, take me back.</g-link>
                </div>
            </div>
        </template>
        <template #footer>
            <div style="text-align: center">
                <powered-by-grin v-if="!isWhiteLabeled" />
            </div>
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../layouts/PageLayout.vue';

    export default {
        name: 'AccountVerificationView',
        components: {
            PageLayout
        },
        props: {
            isWhiteLabeled: {
                type: Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            accountMakesPayments() {
                return this.$root.account_makes_payments;
            }
        },
        methods: {
            sendVerificationEmail() {
                this.$emit('send-verification-email');
            },
            handleSkip() {
                this.$emit('skip-verification');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .margin-bottom-large {
        margin-bottom: $g-spacing-6;
    }

    .margin-bottom-normal {
        margin-bottom: $g-spacing-4;
    }

    .padding-top-normal {
        padding-top: $g-spacing-4;
    }

    .account-verification-block {
        text-align: center;
        margin-top: 8rem;
        margin-bottom: $g-spacing-8;
    }

    .account-verification-text {
        text-align: left;
        padding-left: $g-spacing-9;
        padding-right: $g-spacing-9;
    }

    .verification-methods-block {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .verification-methods-block button {
        width: 200px;
    }

    .verification-methods-block a {
        color: $g-color-grey-6;
    }

    .footer-block {
        padding: $g-spacing-6;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
    }
</style>
